import { GET_INVITES, GET_INVITES_SUCCESS, GET_INVITES_FAILURE } from './types';

export const defaultState = {
	data: [],
	isLoading: false,
	isLoaded: false,
	error: null,
};

export type IInvitesState = typeof defaultState;

export const invites = (state = defaultState, action: any): IInvitesState => {
	switch (action.type) {
		case GET_INVITES:
			return {
				...state,
				isLoading: true,
				error: null,
			};
		case GET_INVITES_SUCCESS:
			return {
				...state,
				data: action.payload,
				isLoading: false,
				isLoaded: true,
				error: null,
			};
		case GET_INVITES_FAILURE:
			return {
				...state,
				isLoading: false,
				isLoaded: true,
				error: action.payload,
			};
		default:
			return state;
	}
};
